module.exports = __webpack_public_path__ + "media/images/views/lp/client/table-sp-56e2e47440c93c0f326cf05b4b01037f.png";